import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {MeetingMinuteForm} from "./MeetingMinuteForm";
import {getMeetingMinutes, updateMeetingMinutes} from "../../../actions/meetingMinutes";

const MeetingMinuteEdit = props => {
  const { meetingminutes, projectid, onSubmit, onCancel } = props;
  return <Card title='Meeting Minutes Details' className={'edit-view'}>
    <MeetingMinuteForm projectid={projectid} meetingMinutes={meetingminutes} onCancel={onCancel} onSubmit={onSubmit}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => {
      let meetingminutes = state.view.subview.data[props.match.params.meetingMinutesId];
      if (!meetingminutes) return { loading: true };
      return { meetingminutes: meetingminutes.resource, projectid: props.match.params.id };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getMeetingMinutes(props.match.params.id, props.match.params.meetingMinutesId)),
      onSubmit: (meetingMinutes) => {
        dispatch(updateMeetingMinutes(props.match.params.id, meetingMinutes));
        props.history.goBack();
      },
      onCancel: () => props.history.goBack()
    })
  ),
  withLoading
)(MeetingMinuteEdit);



// WEBPACK FOOTER //
// ./src/components/Projects/MeetingMinutes/MeetingMinuteEdit.js